// extracted by mini-css-extract-plugin
export var divider = "_rr-0";
export var systemMessage = "_rr-1";
export var systemMessageWrapper = "_rr-2";